<section class="card">
  <!-- Header -->
  <div class="card-header card-header-grid">
    <!-- Search -->
    <div class="input-group input-lined" role="search">
      <div class="input-group-text">
        <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
      </div>
      <input
        class="form-control"
        type="search"
        placeholder="{{ 'general.search' | translate }}"
        attr.aria-label="{{ 'general.search' | translate }}"
        [(ngModel)]="filterTerm"
        (ngModelChange)="onSearch($event)"
      />
    </div>
    <!-- End Search -->

    <div class="d-flex justify-content-end align-items-center">
      <span *ngIf="!showPageFooter">
        {{ (tableData | recursiveFilter: filterTerm)?.length }}
        <span class="ms-2">{{ 'general.total' | translate }}</span>
      </span>
      <span *ngIf="showPageFooter">
        <total-table-counter
          *ngIf="showTotal"
          [page]="activePage"
          [limit]="limitPage"
          [total]="total"
        ></total-table-counter>
        <span *ngIf="!showTotal">
          {{ (tableData | recursiveFilter: filterTerm)?.length }}
          <span class="ms-2">{{ 'general.total' | translate }}</span>
        </span>
      </span>
      <div
        class="btn-group ms-3"
        dropdown
        *ngIf="bulkActions?.length"
        [canSee]="[accessRights.RolePermissions_delete]"
      >
        <button
          class="btn btn-sm btn-white dropdown-toggle"
          type="button"
          aria-controls="bulkAction9"
          dropdownToggle
        >
          {{ 'general.bulkActions' | translate }}
        </button>

        <ul
          *dropdownMenu
          class="dropdown-menu dropdown-menu-right"
          role="menu"
          id="bulkAction9"
        >
          <li *ngFor="let bulkAction of bulkActions">
            <a
              href="javascript:;"
              class="dropdown-item"
              (click)="onClickBulkAction(bulkAction)"
            >
              {{ 'general.' + bulkAction | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- End Header -->

  <!-- Table -->
  <div class="table-responsive">
    <table
      class="table table-borderless table-striped table-hover table-nowrap"
      [mfData]="
        showPageFooter ? tableData : (tableData | recursiveFilter: filterTerm)
      "
      #dataTable="mfDataTable"
      [mfRowsOnPage]="showPageFooter ? limitPage : 25"
    >
      <thead class="table-light">
        <tr>
          <th
            scope="col"
            (click)="onToggleAllChecked()"
            class="cursor-pointer"
            style="max-width: 60px"
          >
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="allCheckedToggle"
              attr.aria-label="{{ 'general.selectAll' | translate }}"
            />
          </th>
          <th scope="col" style="width: 12%">
            <mfDefaultSorter by="id" (click)="onSortfieldClick('id')">
              {{ 'general.id' | translate }}
            </mfDefaultSorter>
          </th>

          <th scope="col" style="width: 25%">
            <mfDefaultSorter
              by="product"
              (click)="onSortfieldClick('productId')"
            >
              {{ 'productModule.product' | translate }}
            </mfDefaultSorter>
          </th>
          <th scope="col" style="width: 18%">
            <mfDefaultSorter
              by="validFrom"
              (click)="onSortfieldClick('validFrom')"
            >
              {{ 'rolePermissionsModule.validFrom' | translate }}
            </mfDefaultSorter>
          </th>

          <th scope="col" style="width: 18%">
            <mfDefaultSorter
              by="validTill"
              (click)="onSortfieldClick('validTill')"
            >
              {{ 'rolePermissionsModule.validTill' | translate }}
            </mfDefaultSorter>
          </th>
          <th scope="col" style="width: 20%">
            <mfDefaultSorter by="role" (click)="onSortfieldClick('roleId')">
              {{ 'general.role' | translate }}
            </mfDefaultSorter>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="
            let item of dataTable.data
              | sortData
                : key
                : sorted
                : { table: 'rolePermissions', entities: '' };
            let i = index
          "
          class="cursor-pointer"
        >
          <td (click)="onCheckRow(item)" class="cursor-pointer">
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="this.checkedIds.get(item.id)"
              attr.aria-label="{{ 'wcag.selectThis' | translate }}"
            />
          </td>
          <td (click)="onRowClicked(item)">#{{ item.id }}</td>
          <td
            (click)="onRowClicked(item)"
            tabindex="0"
            (keyup.enter)="onRowClicked(item)"
          >
            {{ (getProductById(item.product) | async)?.description }}
          </td>
          <td (click)="onRowClicked(item)">
            {{ item.validFrom | date: 'dd-MM-yyyy HH:mm' }}
          </td>
          <td (click)="onRowClicked(item)">
            {{ item.validTill | date: 'dd-MM-yyyy HH:mm' }}
          </td>
          <td (click)="onRowClicked(item)">
            {{ item.role | getRoleDescription | async }}
          </td>
          <!-- <td>
          <a [routerLink]="['/role-permissions/', item.id]" class="fw-bold">
            <i role="img" class="fa fa-eye text-muted"></i>
          </a>
        </td> -->
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td *ngIf="showPageFooter" colspan="10" class="pb-0">
            <table-footer
              class=""
              #footer
              [activePage]="activePage - 1"
              [limitOnPage]="limitPage"
              [totalPages]="pageCount"
              (selectedPage)="selectPage($event)"
              (outNewSearch)="setNewSearch($event)"
              (searchLimit)="setSearchLimit($event)"
            >
            </table-footer>
          </td>

          <td *ngIf="!showPageFooter" colspan="6" class="pb-0">
            <mfBootstrapPaginator
              [rowsOnPageSet]="[25, 50, 100]"
            ></mfBootstrapPaginator>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</section>
